<template>
  <modal
    ref="modal"
    size="xl"
    :show="show"
    :hide-footer="true"
    :show-close-icon="false"
    :minimization-config="minimizationConfig"
    :modal-data="modalData"
    :scrollable="false"
    enforce-focus-on=".cke_dialog_ui_input_text, .copy-to-clipboard-textarea"
    modal-class="goal-modal"
    @hidden="onHidden"
    @hide="$emit('hide', false)"
  >
    <div class="d-flex align-items-center" slot="minimizedView">
      <i class="goal-icon mt-1 flex-shrink-0"></i>
      <span class="ml-2 text-truncate" v-no-capture>{{ goal.title }}</span>
    </div>
    <div class="content mt-3 px-5">
      <goal-viewer
        :goal-id="goal.id"
        :source="source"
        view-type="detail"
        :selectable="false"
        :show-child-goals="false"
      />
      <goal-activity-section :goal="goal" />
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import { ENTITY_TYPE } from '@/constants/entities'
import GoalActivitySection from '@/components/GoalActivitySection.vue'

export default {
  name: 'GoalModal',
  components: {
    Modal,
    GoalViewer: () => import('@/components/GoalViewer'),
    GoalActivitySection
  },
  props: {
    goal: Object,
    show: { type: Boolean },
    modalData: { type: Object },
    minimizable: { type: Boolean, default: true },
    source: String
  },
  data() {
    return {
      minimizationConfig: this.minimizable
        ? {
            type: ENTITY_TYPE.GOAL
          }
        : null
    }
  },
  methods: {
    onHidden() {
      this.$emit('hidden', false)
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_styleConfigurations.scss';
</style>
